import { useEffect, useMemo, useState } from "react";
import { getDocSignatureInfo } from "../../api/papers";

export default function SignTableDocByRole({
  dns,
  project,
  officialMeta,
  showAgentSign = false, // 승인 버튼 클릭 여부
}) {
  const [creator, setCreator] = useState(null);
  const [agent, setAgent] = useState(null);

  /* ===============================
     작성자 사인 (항상 조회)
  =============================== */
  useEffect(() => {
    if (!dns || !project || !officialMeta?.manager?.id) return;

    getDocSignatureInfo(dns, project)
      .then((res) => {
        setCreator(res.data);
      })
      .catch((e) => {
        console.error("작성자 사인 조회 오류", e);
      });
  }, [dns, project, officialMeta]);

  /* ===============================
     현장대리인 사인
     - 승인 버튼 누른 순간(showAgentSign === true)
     - 즉시 조회 → 저장된 사인 표시
  =============================== */
  useEffect(() => {
    if (!showAgentSign) return;
    if (!dns || !project || !officialMeta?.site_agent?.id) return;

    getDocSignatureInfo(dns, project, officialMeta.site_agent.id)
      .then((res) => {
        setAgent(res.data);
      })
      .catch((e) => {
        console.error("현장대리인 사인 조회 오류", e);
      });
  }, [showAgentSign, dns, project, officialMeta]);

  /* ===============================
     표시할 셀 구성
  =============================== */
  const cells = useMemo(() => {
    const result = [];

    if (creator) {
      result.push({
        label: "작성자",
        name: creator.name,
        sign: creator.sign,
      });
    }

    if (showAgentSign && agent) {
      result.push({
        label: "현장대리인",
        name: agent.name,
        sign: agent.sign,
      });
    }

    return result;
  }, [creator, agent, showAgentSign]);

  if (!cells.length) return null;

  /* ===============================
     레이아웃 계산
  =============================== */
  const isSingleCell = cells.length === 1;
  const colWidth = isSingleCell
    ? "120px"
    : `${Math.floor(100 / cells.length)}%`;

  function renderSignatureRow(c) {
    return (
      <div className="relative h-full flex items-center">
        <span
          style={{
            fontSize: "11px",
            position: "absolute",
            left: "6px",
            top: "50%",
            transform: "translateY(-50%)",
            whiteSpace: "nowrap",
          }}
        >
          {c.name}
        </span>

        {c.sign && (
          <img
            src={c.sign}
            alt="sign"
            style={{
              position: "absolute",
              right: "6px",
              top: "50%",
              transform: "translateY(-50%)",
              height: "70px",
              maxWidth: "60px",
              objectFit: "contain",
            }}
          />
        )}
      </div>
    );
  }

  return (
    <div className="flex justify-end w-full">
      <table
        className="border mt-4 text-[12px] text-center border-black w-full"
        style={{ tableLayout: "fixed" }}
      >
        <thead>
          <tr className="bg-gray-100">
            {cells.map((c, i) => (
              <th
                key={i}
                className="border border-black h-[28px]"
                style={{ width: colWidth }}
              >
                {c.label}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          <tr>
            {cells.map((c, i) => (
              <td
                key={i}
                className="border border-black relative h-[36px]"
                style={{ width: colWidth }}
              >
                {renderSignatureRow(c)}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
